import React, { Component } from 'react';
import { Popover, Button, message } from 'antd';
import moment from "moment";
import { inject, observer } from "mobx-react";

@inject('store')
@observer
class Compared extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        }
    }

    addCompared = () => {
        this.setState({ loading: true });
        let data = this.props.data;
        data = {
            ...data,
            title: data.title.toString(),
            add_time: moment().format('YYYY-MM-DD HH:mm:ss')
        }
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {
                contentType: "application/json;charset=utf-8",
            },
            body: JSON.stringify(data)
        }
        fetch('/addCompared', headres).then(x => x.json()).then(x => {
            if (x.status == 1) {
                message.success('添加成功');
            } else {
                message.error('添加失败！');
            }
            this.setState({ loading: false });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        })
    }

    render() {
        const content = (
            <Button
                style={{ width: "100%" }}
                onClick={this.addCompared}
                loading={this.state.loading}
            >
                添加
            </Button>
        );
        // return (
        //     <Popover content={content} title="点击添加到对比数据">
        //         {this.props.children}
        //     </Popover>
        // )
        if (this.props.store.compared.state) {
            return (
                <Popover mouseLeaveDelay={0.2} mouseEnterDelay={0.2} content={content} title={<div style={{ textAlign: 'center' }}>点击添加到对比数据</div>}>
                    {this.props.children}
                </Popover>
            )
        }

        return this.props.children;
    }
}

export default Compared;


// WEBPACK FOOTER //
// ./src/bp-views/table/Compared.js